import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';

import config from './../config';

import ToggleSwitch from './ToggleSwitch';
import StickyWatcher from './StickyWatcher';

import searchIcon from './../images/icon-search.svg';

class SearchBox extends Component {
	constructor(props) {
		super(props);

		this.inputChangeHandler = this.inputChangeHandler.bind(this);
		this.inputKeyDownHandler = this.inputKeyDownHandler.bind(this);
		this.executeSearch = this.executeSearch.bind(this);
		this.inputFocusHandler = this.inputFocusHandler.bind(this);

		this.state = {
			searchBoxInput: '',
			personNameSearchInput: '',
			extendedSearchInput: false
		};
	}

	componentDidMount() {
		var stateObj = this.state;

		if (this.props.searchString) {
			stateObj.searchBoxInput = this.props.searchString;
		}
		if (this.props.beygingarmynd) {
			stateObj.extendedSearchInput = this.props.beygingarmynd;
		}

		this.setState(stateObj);

		this.refs.searchInput.focus();

		setTimeout(function() {
			this.inputFocusHandler();
		}.bind(this), 100);
	}

	componentDidUpdate(prevProps, prevState) {
		var stateObj = this.state;

		var stateChanged = false;

		if (this.props.searchString != prevProps.searchString) {
			stateObj.searchBoxInput =this.props.searchString;

			stateChanged = true;
		}

		if (this.props.beygingarmynd != prevProps.beygingarmynd) {
			stateObj.extendedSearchInput =this.props.beygingarmynd;

			stateChanged = true;
		}

		if (stateChanged) {
			this.setState(stateObj);
		}
	}

	inputChangeHandler(event) {
		let value = event.target.type && event.target.type == 'checkbox' ? event.target.checked : event.target.value;

		var stateObj = {};

		stateObj[event.target.name] = value;

		if (event.target.name == 'personNameSearchInput') {
			stateObj['searchBoxInput'] = ''
		}
		if (event.target.name == 'searchBoxInput') {
			stateObj['personNameSearchInput'] = ''
		}
		
		this.setState(stateObj);
	}

	inputKeyDownHandler(event) {
		if (event.keyCode == 13) { // enter
			this.executeSearch(event.target.name);
		}
	}

	inputFocusHandler(event) {
		event.targe.select();
	}

	executeSearch(event) {
		if (this.state.searchBoxInput != '') {
			let basePath = '/leit/ornefni/';

			if (this.props.location.pathname.startsWith('/leit/kort/')) {
				basePath = '/leit/kort/';
			}
			this.props.history.push(basePath+(this.state.extendedSearchInput ? 'extended/' : '')+this.state.searchBoxInput);
		}
		if (this.state.personNameSearchInput != '') {
			this.props.history.push('/leit/mannanofn/'+this.state.personNameSearchInput);
		}
	}

	render() {
		let enSite = this.props.lang && this.props.lang == 'en';

		return (
			<StickyWatcher className={'search-form'}
				stickyClassName="sticky"
				useBodyTag={false}
				manual={true}
				top={161}
				minScreenWidth={550}
				onStick={function() {
					document.body.classList.add('search-form-sticky');
				}}
				onUnStick={function() {
					document.body.classList.remove('search-form-sticky');
				}}
			>
				<div className="container larger">


						<div className="form-group column-content">

							<div className="row">
								<div className="col-12 col-md-7 col-lg-7">

									<div className="d-flex">
										<div className="flex-grow-1 mr-2 mr-sm-4">
											<input className="form-control "
												ref="searchInput"
												name="searchBoxInput"
												value={this.state.searchBoxInput}
												type="text"
												onChange={this.inputChangeHandler}
												onKeyDown={this.inputKeyDownHandler}
												onFocus={this.inputFocusHandler}
												placeholder={'Bæjarnafn eða annað örnefni'}
											/>
										</div>

										{/*
										<div className="flex-grow-1 mr-2 mr-sm-4">
											<input className="form-control "
												ref="personNameSearchInput"
												name="personNameSearchInput"
												value={this.state.personNameSearchInput}
												type="text"
												onChange={this.inputChangeHandler}
												onKeyDown={this.inputKeyDownHandler}
												onFocus={this.inputFocusHandler}
												placeholder={'Nöfn Íslendinga'}
											/>
										</div>
										*/}

										<button onClick={this.executeSearch.bind(this)} className="btn btn-primary">
											<span className="label">{enSite ? 'Search' : 'Leita'}</span>
											<span className="icon"><img src={searchIcon} /></span>
										</button>
									</div>

									<div className="form-group form-check float-right">
										<div style={{
											display: 'none',
											pointerEvents: 'none',
											opacity: 0
										}}><ToggleSwitch label={'Leita í texta'} onChange={this.inputChangeHandler} name="extendedSearchInput" value={this.state.extendedSearchInput} /></div>
									</div>

								</div>

								<div className="col-12 col-md-5 col-lg-5 pl-4 extra-buttons">
									<label>Fletta í safni</label>
									<Link className="btn btn-secondary" to="/sveitarfelog/">Sveitarfélög</Link> <Link className="btn btn-secondary" to="/syslur/">Sýslur</Link> <Link className="btn btn-secondary" to="/kort/">Kort</Link>

								</div>
							</div>

							<div className="clearfix" />

						</div>


					<div className="loading-bar">
						<div className="indicator" />
					</div>

				</div>
			</StickyWatcher>
		);
	}
}

export default withRouter(SearchBox);



// WEBPACK FOOTER //
// ./src/components/SearchBox.js